// * Define Months
var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// * not needed
// export const convertDateFormatBeginningOfMonth = (date) => {
//     var month1 = months.indexOf(date?.split(' ')[0])
//     return new Date(date?.split(' ')[2] + '-' + (month1 + 1) + '-01')
// };

// from MMM dd yyyy to yyyy-MM-dd
export const changeDateFromMMMDDYYYYToYYYYMMDD = (date) => {
    var dateSplitArray = date?.split(' ');
    var month = months.indexOf(dateSplitArray[0]);
    if (month + 1 < 10) {
        month = `0${month + 1}`;
    };
    return `${dateSplitArray[2]}-${month}-${dateSplitArray[1]}`;
};

// from yyyy-MM-dd to dd/MM/yyyy
export const changeDateFromYYYYMMDDToDDMMYYYY = (date) => {
    var dateSplitArray = date?.split('-');
    return `${dateSplitArray[2]}/${dateSplitArray[1]}/${dateSplitArray[0]}`;
};

// from dd/MM/yyyy to yyyy-MM-dd 
export const changeDateFromDDMMYYYYtoYYYYMMDD = (date) => {
    var dateSplitArray = date?.split('/');
    return `${dateSplitArray[2]}-${dateSplitArray[1]}-${dateSplitArray[0]}`;
};


export const getMonthFromDDMMYYYY = (date) => {
    var dateSplitArray = date?.split('/');
    return `${dateSplitArray[1]}`;
};

export const formatDateForUI = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return '';
    const [dateOnly] = dateStr.split('T');
    return changeDateFromYYYYMMDDToDDMMYYYY(dateOnly);
};

export const MONTHNAMES = [
    'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
]

export const DAYNAMES = [
    'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday',
]
